<template>
<div>
  <transition name="slide-fade">
  <div v-if="panelShow" class="panel" @mouseenter="trashDisplay='inline'" @mouseleave="trashDisplay='none'">
  <el-card>
    <!-- header -->
    <div slot="header">
      美钥码ID：{{getNewQrId(myqrinfo.qrid,myqrinfo.qrtype.qrtypeid)}}
      <span class="qr_name" style="margin-left:10px;">
        名称：
        <template v-if="editNameStatus">
          <el-input v-focus v-model="editQrnameValue" size="small" style="width: 200px;" type="text" placeholder="请输入名称" @blur="changeQrname"></el-input>
        </template>
        <template v-else>
          <span @click="editQrname" :style="{color: myqrinfo.qrname === '' ? 'gray' : 'black'}">{{qrnameShow}}<span style="color:#6c6c6c"><i class="fa fa-edit qrname_edit fa-sm"></i></span>
          </span>
        </template>
      </span>
      <span :style="{ display: trashDisplay}" style="float: right; cursor: pointer">
          <i class="fa fa-trash" @click="deleteQrConfirmDialogShow=true"></i>
      </span>
    </div>
    <!-- content -->
    <el-row>
      <el-col :span="2">
        <img alt="美钥二维码" style="width: 100%; max-width: 80px; cursor: pointer;" :src="myqrinfo.qrfile"
          @click="bigQrViewDialogShow = true">
      </el-col>
      <el-col :span="22">
        <el-row>
          <el-col :span="18">
            <small class="block">类型：{{myqrinfo.qrtype.qrtypedesc}}</small>
            <!-- <small class="block">截止时间：<span v-if="userLevel === '1'">{{myqrinfo.qrdeadline}}</span><span v-if="userLevel !== '1'">无期限</span></small> -->
            <small class="block">
              <span v-if="myqrinfo.qrtype.qrtypedesc === '文本'">标题</span>
              <span v-else>{{myqrinfo.qrtype.qrtypedesc}}：</span>
              <span v-if="!editQrContentStatus">
                {{qrContentShow}}
                <i class="el-icon-edit" @click="editQrContentInit" style="cursor: pointer"></i>
              </span>
              <span v-else>
                <template v-if="myqrinfo.qrtype.qrtypeid==='WEBSITE'">
                  <el-input v-focus v-model="editQrContentValue" size="small" style="width: 500px;" @blur="editQrContentStatus = false">
                    <!--注意，此处绑定不能用click，而只能用blur，应为click与上边的blur冲突-->
                    <span slot="append" @mousedown="editQrContent" style="cursor:pointer">保存</span>
                  </el-input>
                </template>
                <!-- <template v-else-if="myqrinfo.qrtype.qrtypeid==='TEXT'">
                  <textarea type="text" rows="5" v-model="editQrContentValue"
                    @blur="editQrContentStatus = false"></textarea> 
                  <div class="input-group-btn" style="cursor:pointer;" > -->
                  <!--注意，此处绑定不能用click，而只能用blur，应为click与上边的blur冲突-->
                    <!-- <button class="btn btn-white btn-small" @mousedown="editQrContent">
                    保存
                    </button>
                  </div>
                </template> -->
              </span>
            </small>
            <small class="block" v-if="myqrinfo.qrtype.qrtypeid !== 'WEIXIN'">总扫描次数：{{myqrinfo.qrscancount}}次</small>
            <small class="block" v-if="myqrinfo.qrtype.qrtypeid === 'WEIXIN'">微信美钥码暂无统计数据</small>
            <small class="block" v-if="myqrinfo.qrtype.qrtypeid !== 'WEIXIN'">截止时间：<span v-if="userLevel === '1'">{{myqrinfo.qrdeadline}}</span><span v-if="userLevel !== '1'">无期限</span></small>
          </el-col>
          <el-col :span="6">
            <span v-if="userLevel === '1' && myqrinfo.qrtype.qrtypeid !== 'WEIXIN'"><a class="btn-again" @click="delayTimeDialogShow = true" style="cursor:pointer;">立即延时</a></span>
            <!-- <span><a :href="'/v1/user/qrs/' + myqrinfo.qrid + '/qrfile'" class="btn-again">下载</a></span> -->
            <span class="btn-again" @click="downloadQrImage()">下载</span>
            <span class="btn-again" @click="openBigQrViewDialogShow()">详情</span>
          </el-col>
        </el-row>
        <el-row>
          <span class="edit-labels" :id="selectLabelTipBindId">
          <i class="fa fa-tags"></i> 标签 <i class="fa fa-caret-down"></i>
          </span>
          <!-- 显示标签序列 -->
          <span v-for="lb in sortedLabels" :style="{background: lb.color}" class="qr-label" :key="lb.qrid">{{lb.textDesc}}</span>
        </el-row>
      </el-col>
    </el-row>
  </el-card>
  </div>
  </transition>

 <!--- 为二维码增加或者减少便签的tip -->
  <div :id="selectLabelContentId" class="selectLabelContent">
    <ul>
      <template v-for="qrlabel in qrlabelList">
        <li @click="labelToggle(myqrinfo.qrid, qrlabel.id)" :key="qrlabel.id">
          <span class="checkbox" :class="{checked:labelIsChecked(qrlabel.id)}"><i class="fa fa-check"></i></span>
          <span class="label-name">{{qrlabel.textDesc}}</span>
          <span class="label-color" :style="{background: qrlabel.color}"></span>
        </li>
      </template>
    </ul>
  </div>

   <!-- 删除页面模态框提示 -->
  <el-dialog :visible.sync="deleteQrConfirmDialogShow" title="提示">
    <span>
      <h3>您确定要删除该二维码吗？</h3>
      <p>删除后，该二维码将会停止解析，当再次扫描该二维码时，将不能跳转到指定页面，同时该二维码的所有扫描记录也会被删除。</p>
    </span>
    <span slot="footer">
      <el-button @click="deleteQrConfirmDialogShow = false">取 消</el-button>
      <el-button type="primary" @click="deleteQr">确 定</el-button>
    </span>
  </el-dialog>

  <!-- 二维码详细界面 -->
  <el-dialog :visible.sync="bigQrViewDialogShow" title="美钥二维码" :key="myqrinfo.qrid">
    <div style="text-align: center">
      <img alt="美钥二维码大图" :src="myqrinfo.qrfile" width="300px;" height="300px;">
    </div>
    <div style="line-height:33px;;width:80%;margin-left:20%;margin-top:30px;font-size:20px;height:auto;overflow:hidden;">
                       美钥码名称：{{qrName}}<br>
                       创建时间：&nbsp;&nbsp;&nbsp;{{myqrinfo.qrregistertime}}<br>
                       过期时间：&nbsp;&nbsp;&nbsp;{{qrdeadline}}<br>
                       美钥码种类：{{myqrinfo.qrtype.qrtypedesc}}<br>
                       美钥码链接：{{myqrinfo.qrdest}}<br>
                       扫描总次数：{{myqrinfo.qrscancount}}<br>
                       标签：<span class="tips" v-for="l in myqrinfo.qrlabels" v-bind:key="l.qrid" :style="{background: l.color}">{{l.textDesc}}</span></div>
                       <!-- <span v-for="lb in sortedLabels" :style="{background: lb.color}" class="qr-label" :key="lb.qrid">{{lb.textDesc}}</span> -->
    <div slot="footer" style="text-align: center;margin-top:0px;">
      <el-button v-if="myqrinfo.qrtype.qrtypeid !== 'WEIXIN'" type="primary" @click="$router.push('/analysis/scan/labelid/all/n/5/p/1/?qrid='+myqrinfo.qrid+'&qrname='+myqrinfo.qrname)">扫码数据统计</el-button>
      <el-button type="primary" v-if="myqrinfo.qrtype.qrtypeid == 'WEBSITE' && myqrinfo.remarks && JSON.parse(myqrinfo.remarks).track_code" @click="trackQr(myqrinfo)">目标页面用户数据追踪</el-button>
      <el-button type="primary" @click="downloadQrImage()">下载二维码</el-button>
    </div>
  </el-dialog>


  <!-- 立即延时页面提示 -->
  <el-dialog :visible.sync = "delayTimeDialogShow" title="美钥二维码解析延时">
    <div>
      <p>每个美钥二维码均会占用一个独一无二的资源地址。为保证美钥码资源地址被充分利用，您所使用的账户: <br/>
      </p>
      <p>
      <strong>需要在二维码解析时间到期前的10天之内，对二维码进行延时操作，以保证其能够被持续解析。否则，美钥二维码官网将会对其停止解析。</strong><br/>
      </p>
      <p>每次延时操作，解析时间将会增加15天。<br/>建议您将不需要的美钥码进行删除，以方便他人使用该资源地址。
      </p>
      <hr style="border:0.25px solid #ddd;"/>
      <p style="color:#a39898;">如果您有大量或者需要长期维护的二维码资源，可以购买付费版套餐，付费版套餐用户的美钥码将会自动延时。</p>
    </div>
    <div slot="footer" style="text-align: center;">
      <el-button type="primary" @click="delayQrTime">立即延时</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script type="text/javascript">
import $ from 'jquery'
import '@pp/qtip/jquery.qtip.min.css'
import '@pp/qtip/jquery.qtip.min.js'
import { mapGetters } from 'vuex'
export default {
  name: 'qrInfoPanel',
  props: ['qrinfo', 'userLevel'],
  data () {
    return {
      myqrinfo: this.qrinfo,
      selectLabelTipBindId: 'selectLabelTipBind-' + this.qrinfo.qrid,
      selectLabelContentId: 'selectLabelContentId-' + this.qrinfo.qrid,
      qtipApi: null,
      editNameStatus: false, // 是否处于名称编辑状态
      editQrnameValue: this.qrinfo.qrname, // 编辑框中qr名称的值
      editQrContentStatus: false, // 二维码包含内容是否处于编辑状态
      editQrContentValue: this.qrinfo.qrdest, // 二维码编辑框内容
      bigQrViewDialogShow: false, // 是否显示大图
      trashDisplay: 'none',
      delayTimeDialogShow: false, // 延时窗口显示
      panelShow: true,
      deleteQrConfirmDialogShow: false
    }
  },
  computed: {
    ...mapGetters([ 'qrlabelList' ]),
    qrName () {
      if (this.myqrinfo.qrname !== '') {
        return this.myqrinfo.qrname
      } else {
        return '未命名'
      }
    },
    qrdeadline () {
      if (this.userLevel === '1') {
        return this.myqrinfo.qrdeadline
      } else {
        return '无期限'
      }
    },
    qrnameShow () {
      if (this.myqrinfo.qrname === '') {
        return '未命名'
      } else {
        return this.myqrinfo.qrname
      }
    },
    sortedLabels () {
      let labels = this.myqrinfo.qrlabels.slice()
      return labels.sort(function (x, y) {
        if (x.rank < y.rank) {
          return -1
        } else if (x.rank > y.rank) {
          return 1
        } else {
          return 0
        }
      })
    },
    qrContentShow () {
      if (this.myqrinfo.qrdest.length > 30) {
        return this.myqrinfo.qrdest.substr(0, 30) + '...'
      } else {
        return this.myqrinfo.qrdest
      }
    }
  },
  mounted () {
    const vm = this
    vm.qtipApi = $('#' + this.selectLabelTipBindId).qtip({
      hide: 'unfocus',
      show: 'click',
      position: {
        my: 'top center',
        at: 'bottom center'
      },
      style: {
        classes: 'qtip-bootstrap' // 风格
      },
      content: {
        title: '编辑二维码标签',
        text: '还没有标签，赶快新建一个吧'
        // text 内容主要在show函数中动态加载，在show函数中通过api set进入内容，
        // 这样，方便动态响应标签种类变化，而不是在mounted时确定
      },
      events: {
        show: function (event, api) {
          // 当有标签时，显示标签
          if (vm.qrlabelList.length > 0) {
            // 注意此处用的是对象，而不是$('#' + vm.selectLabelContentId).html()
            // 因为，如果用对象，将与vue用的是同一个对象，方便在便签增多或者减少时，vue进行对应的更新，同时，保证响应动作有效
            // 而如果用html，则相当于拷贝，将不能很好响应标签上的动作。
            api.set('content.text', $('#' + vm.selectLabelContentId))
          }
        }
      }
    }).qtip('api')
  },
  beforeDestroy () {
    this.qtipApi.destroy(true)
  },
  methods: {
    openBigQrViewDialogShow () {
      this.bigQrViewDialogShow = true
    },
    trackQr (qrinfo) {
      window.open("/wechat_page_track/qr/"+qrinfo.qrid+ "/track_code/"+JSON.parse(qrinfo.remarks).track_code); 
    },
    // 对一个二维码的标签进行添加，或者删除
    labelToggle (qrid, labelid) {
      // 判断目前该二维码是否有此标签，即标签所处状态
      let exist = this.labelIsChecked(labelid)
      const vm = this
      if (exist) { // 存在该标签，则删除标签，同时，更新vuex中数据
        // 删除标签
        // 现在数据库中删除成功
        $.ajax({
          url: '/v1/user/qrs/' + qrid + '/qrlabels/' + labelid,
          type: 'DELETE',
          dataType: 'json'
        })
        .done(function (data) {
          if (data.code === 200) {
            // 找出对应id的标签，并将对应的数量-1
            vm.$store.dispatch('labelNumMinusOne', labelid)
            let idx = vm.myqrinfo.qrlabels.findIndex(function (item) {
              return item.id === labelid
            })
            if (idx !== -1) {
              vm.myqrinfo.qrlabels.splice(idx, 1)
            }
          } else {
            vm.$message.warning('删除失败，请稍后重试')
          }
        })
        .fail(function () {
          vm.$message.warning('删除失败，请稍后重试')
        })
      } else { // 不存在该便签，则添加便签，同时，更新vuex中数据
        // 现在数据库中删除成功
        $.ajax({
          url: '/v1/user/qrs/' + qrid + '/qrlabels/' + labelid,
          type: 'POST',
          dataType: 'json'
        })
        .done(function (data) {
          if (data.code === 200) {
            // 找出对应id的标签，并将对应的数量+1
            vm.$store.dispatch('labelNumAddOne', labelid)
            // 找出对应的标签，复制，并放到myqrinfo中
            let lb = vm.qrlabelList.find(function (item) {
              return item.id === labelid
            })
            vm.myqrinfo.qrlabels.push($.extend({}, lb))
          } else {
            vm.$message.warning('添加失败，请稍微重试')
          }
        })
        .fail(function () {
          vm.$message.warning('删除失败，请稍后重试')
        })
      }
    },
    // 判断该labelid是否已经处于勾选状态
    labelIsChecked (labelid) {
      return this.myqrinfo.qrlabels.some(function (item) {
        return item.id === labelid
      })
    },
    // 编辑二维码名称
    editQrname () {
      this.editNameStatus = true
    },
    // 修改某个二维码的名称
    changeQrname () {
      this.editNameStatus = false
      const vm = this
      $.ajax({
        url: '/v1/user/qrs/' + this.myqrinfo.qrid + '/name',
        type: 'PUT',
        dataType: 'json',
        data: {
          qrname: vm.editQrnameValue
        }
      })
      .done(function (data) {
        if (data.code === 200) {
          vm.myqrinfo = data.data
        } else {
          vm.$message.warning('更新二维码名称失败！')
        }
      })
      .fail(function () {
        vm.$message.warning('修改失败，请稍后重试！')
      })
    },
    editQrContent () {
      this.editQrContentStatus = false
      const vm = this
      $.ajax({
        url: '/v1/user/qrs/' + this.myqrinfo.qrid + '/content',
        type: 'PUT',
        dataType: 'json',
        data: {
          qrdest: vm.editQrContentValue
        }
      })
      .done(function (data) {
        if (data.code === 200) {
          vm.myqrinfo = data.data
        } else {
          vm.$message.warning('更新二维码内容失败！')
        }
      })
      .fail(function () {
        vm.$message.warning('修改失败，请稍后重试！')
      })
    },
    editQrContentInit () {
      if (this.myqrinfo.qrtype.qrtypeid === 'TEXT') {
        // this.$router.push('/editText?id=' + this.myqrinfo.qrid)
        window.open('/editText?id=' + this.myqrinfo.qrid)
      } else if (this.myqrinfo.qrtype.qrtypeid === 'WEIXIN') {
        this.$message.warning('微信美钥码内容无法编辑！')
      } else if (this.myqrinfo.qrtype.qrtypeid === 'IDCARD') {
        this.$message.warning('名片美钥码内容无法编辑！')
        // window.open('/idCardQr?qrid=' + this.myqrinfo.qrid + '&edit=true')
      } else {
        this.editQrContentStatus = true
        this.editQrContentValue = this.myqrinfo.qrdest
      }
    },
    // 删除一个qr
    deleteQr () {
      const vm = this
      $.ajax({
        url: '/v1/user/qrs/' + this.myqrinfo.qrid,
        type: 'DELETE',
        dataType: 'json'
      })
      .done(function (data) {
        if (data.code === 200) {
          // 将对应的标签删掉，并通知对应数据减少
          for (let i = 0; i < vm.myqrinfo.qrlabels.length; i++) {
            vm.$store.dispatch('labelNumMinusOne', vm.myqrinfo.qrlabels[i].id)
          }
          vm.deleteQrConfirmDialogShow = false
          vm.panelShow = false
        } else {
          vm.$message.warning('删除失败，请稍后重试！')
        }
      })
      .fail(function () {
        vm.$message.warning('删除失败，请稍后重试！')
      })
    },
    downloadQrImage () {
      // let ua =Window.navigator.userAgent.toLowerCase()
      // if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      //   this.$message.warning('微信浏览器请长按图片保存')
      // }
      this.$message.info('微信浏览器请长按图片保存')
      window.location = '/v1/user/qrs/' + this.myqrinfo.qrid + '/qrfile'
      this.bigQrViewDialogShow = false
    },
    // 为一个二维码延时
    delayQrTime () {
      const vm = this
      $.ajax({
        url: '/v1/user/qrs/' + this.myqrinfo.qrid + '/time',
        type: 'PUT',
        dataType: 'json'
      })
      .done(function (data) {
        if (data.code === 200) {
          vm.myqrinfo = data.data
          vm.$message.success('延时成功，延长至' + vm.myqrinfo.qrdeadline)
        } else if (data.code === 300004) {
          vm.$message.warning('会员用户美钥码无需手动延时')
        } else {
          vm.$message.warning('剩余时间充足，暂时不需要延时')
        }
        vm.delayTimeDialogShow = false
      })
      .fail(function () {
        vm.$message.warning('延时操作失败，请稍后重试！')
      })
    }
  },
  watch: {
    // 检测qrlableList修改，如果有变化，则核对自己的标签，对标签进行同步
    qrlabelList: function (newlabelList) {
      // 同步每个标签情况，需要查询是否在新列表中，如果在，则说明有可能更改了颜色或名字等，
      // 如果不在，则说明被删除
      let newInfoLabels = []
      this.myqrinfo.qrlabels.forEach(function (item) {
        let std = newlabelList.find(function (newlabel) {
          return newlabel.id === item.id
        })
        if (std !== undefined) {
          newInfoLabels.push($.extend({}, std))
        } // 否则，未找到，说明标签被删除
      })
      this.myqrinfo.qrlabels = newInfoLabels
    }
  },
  directives: {
    focus: {
      inserted (el) {
        // el-input生成了一个div，包含一个input，所以，需要把焦点查询一下，放在input上。
        el.querySelector('input').focus()
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.tips{
  font-size:18px;
  margin:0 5px 0 5px;
  padding: 2px 4px;
  color:#fff;
  
}
.qrname_edit{
  margin-left: 5px;
  cursor: pointer;
  /* font-size: medium; */
}
.item-label-name{
  display: inline-block;
}
.edit-label-icon{
    font-size: 12px;
    color: #fff;
}
.item-label-id{
  display: none;
}
.qr_name {
  padding-left: 0px;
}
.panel {
  margin: 10px 15px;
  min-width: 500px;
}
.panel-heading{
  border: 1px solid #e0e4e8;
}
.panel-content{
  margin: 10px 10px;
}
.panel-footer{
  border: 1px solid #e0e4e8;
  margin-left: 0px;
  margin-right: 0px;
}
.icon-trash{
  cursor: pointer;
  font-size: medium;
}
.icon-trash:HOVER{
  color: #000;
}

.btn-again{
  display: inline-block;
  padding: 2px 0 3px;
  border: 1px solid #ddd;
  border-radius: 2px;
  text-align: center;
  width: 85px;
  color: gray;
  text-decoration: none;
}

.btn-again:HOVER{
  background: #fff;
  border-color: #e4393c;
  color: #e4393c;
  cursor: pointer;
}

.edit-labels{
  display: inline-block;
  padding: 1px 5px;
  color: #777;
  border: 1px solid #999;
  border-radius: 2px;
  font-size: 10px;
  line-height: 13px;
  cursor: pointer;
  user-select: none;
  bottom: 0px;
}
.edit-labels:HOVER{
  color: #000;
  border: 1px solid #000;
}
.qr-label{
  display: inline-block;
  padding: 1.5px 4px 1.5px 4px;
  margin-right: 3px;
  border-width: 1px;
  border-radius: 2px;
  border-style: solid;
  line-height: 15px;
  color: #fff;
  font-size: 12px;
  font-weight: 300;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.media-body .block{
  margin-bottom: 7px;
}
.qrname_edit:HOVER{
  color: #000;
}

.selectLabelContent{
  display: none;
  margin: 5px 0 0 0;
  max-height: 180px;
  overflow-y: auto;
}

ul {
  padding: 0;
  margin: 0 0 2px 0;
  display: block;
  list-style-type: none;
}
li {
  display: inline-block;
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  margin: 0;
  list-style: none;
  font-size: 13px;
  cursor: pointer;
  line-height: 20px;
  display: list-item;
  text-align: -webkit-match-parent;
}
span.checkbox {
  display: inline-block;
  position: relative;
  margin: 0 2px 2px 0;
  padding: 0;
  width: 13px;
  min-height: 0;
  height: 13px;
  top: 4px;
  border: 1px solid #999;
  border-radius: 2px;
  font-size: 13px;
}
.label-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 0px;
  border-radius: 2px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 0px;
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 2px;
  border-width: 1px;
}
.fa-check {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
}
.checked .fa-check {
  display: inline;
}
.fa-check:before {
  margin-left: 0;
}
/* 可以设置不同的进入和离开动画 */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: opacity .5s
}
.slide-fade-enter, .slide-fade-leave-active {
  opacity: 0
}
.block{
  display:block;
  margin-bottom: 5px;
}

</style>
